import React from "react";
import CardPrimary from "../../component/Card/CardPrimary";
import Jumbotron from "../../component/Jumbotron";
import Text from "../../component/Text";

const cards = [
  {
    heading: "Publishing TWA to playstore",
    linkUrl:
      "https://rajanlagah.medium.com/publishing-twa-to-playstore-664f2ac6f325",
    content:
      "Want to publish your website's PWA to playstore ? Learn how to do this",
    tagList: ["Playstore", "PWA", "TWA"],
  },
  {
    heading: "Context API in React",
    linkUrl: "https://rajanlagah.medium.com/context-api-in-react-9c32b5c44deb",
    content: "Sharing state and function b/w React components",
    tagList: ["React"],
  },
  {
    heading: "JOIN in SQL",
    linkUrl: "https://rajanlagah.medium.com/join-in-sql-aadb572256b9",
    content: "Started code of react with login/signup/logout graphql APIs ",
    tagList: ["Sql"],
  },
  {
    heading: "Er diagram explained",
    linkUrl: "https://rajanlagah.medium.com/er-diagram-explained-8f79c442ec84",
    content: "Database design for reddit clone app",
    tagList: ["UML"],
  },
];

const Blogs = () => (
  <Jumbotron
    minHeight="100vh"
    flexDirection="column"
    justifyContent="center"
    textAlign="center"
  >
    <Text text="BLOGS" fs="60px" fontWeight="bold" />
    <Text
      text="rajanlagah.medium.com"
      fs="30px"
      fontWeight="200"
      margin="20px 0 0 0"
    />
    <Text text="500+ views/month" fs="26px" fontWeight="200" margin="0" />
    <Jumbotron height="70%" padding="100px 30px" width="100%" >
      {cards.map((card) => (
        <CardPrimary key={card.heading} {...card} />
      ))}
    </Jumbotron>
  </Jumbotron>
);

export default Blogs;
